import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader } from '../ui/card';
import { StatusBadge } from '../ui';

function formatDateTime(tsSeconds: number | null | undefined) {
  if (!tsSeconds) return '—';
  return new Date(tsSeconds * 1000).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' });
}

export type LinkedJobItem = {
  id: string;
  bookingId: string;
  jobStatus: string;
  createdAt: number;
  completedAt: number | null;
};

export function LinkedJobsSection({ jobs }: { jobs: LinkedJobItem[] }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="text-sm font-semibold">Trabajos vinculados</div>
          <div className="text-xs text-muted-foreground">{jobs.length}</div>
        </div>
      </CardHeader>
      <CardContent>
        {jobs.length === 0 ? (
          <div className="text-sm text-muted-foreground">No hay trabajos vinculados.</div>
        ) : (
          <div className="space-y-2">
            {jobs.map((j) => (
              <div key={j.id} className="rounded-lg border px-3 py-2 bg-gray-50 flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <Link to={`/jobs?jobId=${encodeURIComponent(j.id)}`} className="text-sm font-medium text-blue-600 hover:underline">
                    Abrir trabajo
                  </Link>
                  <div className="text-xs text-muted-foreground mt-0.5">
                    {formatDateTime(j.createdAt)}
                    {j.completedAt ? ' · Cerrado' : ''}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <StatusBadge status={j.jobStatus} />
                  <Link to={`/bookings/${j.bookingId}`} className="inline-flex items-center gap-1 text-xs text-gray-600 hover:text-gray-800">
                    Cita <ExternalLink className="h-3 w-3" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
